// extracted by mini-css-extract-plugin
export default {"page":"Login_page__Fj2mW","brand-wrapper":"Login_brand-wrapper__ZpmWc","form-wrapper":"Login_form-wrapper__0wXNy","terms":"Login_terms__W+UhE"};